<template>
  <section>
    <label
      ><small
        v-show="boards.required"
        class="text-danger"
        >*</small
      >
      Quadros:</label
    >
    <div class="input-group">
      <b-form-select
        autofocus
        @change="loadColumns(boards.value)"
        :required="boards.required"
        v-model="boards.value"
        :options="boards.listOptions"
        placeholder="Selecione o quadro"
        class="w-100"
        label="text"
      >
        <template v-slot:no-options>Nenhum quadro encontrado.</template>
      </b-form-select>
    </div>
  </section>
</template>

<script>
import BoardRepository from '@/shared/http/repositories/crm/board.js'

export default {
  name: 'SelectBoard',
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedOption: {
      type: Number | String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      boards: { listOptions: [], value: null, required: true }
    }
  },
  created () {
    this.loadBoards()
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler: function (newVal) {
        this.boards.value = newVal
      }
    }
  },
  methods: {
    loadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          let activeOptions = res.data.content
            .filter(
              (x) =>
                x.id != null && x.arquivado !== true && x.isReadOnly !== true
            )
            .map((x) => ({ value: x.id, text: x.nome }))

          let filedOptions = res.data.content
            .filter(
              (x) =>
                x.id != null && x.arquivado === true && x.isReadOnly !== true
            )
            .map((x) => ({ value: x.id, text: x.nome }))

          let options = []

          if (this.onlyActive) {
            options = activeOptions
          } else {
            options = [
              {
                label: 'Quadros Ativos',
                options: activeOptions
              },
              {
                label: 'Quadros Arquivados',
                options: filedOptions
              }
            ]
          }

          this.boards.listOptions = options
        })
        .catch(this.onException)
    },
    loadColumns (boardId) {
      this.$emit('onSelect', boardId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/selects/SelectBoard.vue